import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {ColorEvent} from 'ngx-color';
import {TdoColorPickerEvent} from './models/tdo-color-picker.event';

@Component({
  selector: 'app-tdo-color-picker',
  templateUrl: './tdo-color-picker.component.html',
  styleUrls: ['./tdo-color-picker.component.css']
})
export class TdoColorPickerComponent implements OnInit {
  @Input() color: string = '#ffffff';
  @Input() placeholder: string;
  @Input() showInputField: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() width: number = 20;
  @Input() height: number = 20;
  @Input() labelColor = 'grey';
  @Input() label: string = 'Color';
  @Input() pickerPosition = 'bottom';
  @Output() colorChange: EventEmitter<TdoColorPickerEvent> = new EventEmitter<TdoColorPickerEvent>();

  positionY = 10;

  isShowColorPicker: boolean;

  /*@HostListener('document:mousedown', ['$event.target'])
  onClick(target) {
    if (!this.elementRef.nativeElement.contains(target)) {
      console.log('Clicked outside!');
      this.isShowColorPicker = false;
    } else {
      console.log('Clicked inside!');
    }
    // console.log('button', btn, 'number of clicks:', this.numberOfClicks++);
  }*/

  constructor(public elementRef: ElementRef) {
    //
  }

  onColorChange(event: ColorEvent) {
    this.color = event.color.hex;
    const ce = new TdoColorPickerEvent();
    ce.hex = event.color.hex;
    this.colorChange.emit(ce);
  }

  ngOnInit(): void {
    console.log('Picker position: ' + this.pickerPosition);
    if (this.pickerPosition === 'top') {
      this.positionY = -230;
    }
  }
}
